import { CanvassingQANotificationFrequency } from './canvassingQaNotifications';
import { Role } from './role';
import { InviteStatus } from './userOrg';

export type OrgType = {
  id: string;
  created_at?: Date;
  updated_at?: Date;
  slug: string;
  org_type: string;
  name: string;
  candidate_name?: string;
  opponent?: string;
  picture_url?: string;
  email?: string;
  phone_number?: string;
  callback_phone_number?: string;
  race_typeRace?: string;
  election_type?: string;
  selected_state?: string;
  selected_state_list?: string[];
  selected_city?: string;
  selected_county?: string;
  selected_congressional_district?: string;
  selected_senate_district?: string;
  selected_house_district?: string;
  selected_jurisdiction?: string;
  model_coefficients?: string[];
  rnc_shareback?: boolean;
  is_active?: boolean;
  election_day?: Date;
  deactivated_at?: Date;
  mv_created?: boolean;
  data_source?: string;
  using_2022_data?: boolean;
  using_cf_data?: boolean;
  using_lower_district_sub_data?: boolean;
  subscription?: string;
  last_refresh?: Date;
  testing_channel?: string;
  twilio_flow_id?: string;
  uploadcare_uuid?: string;
  signed_url?: string;
  needs_refresh?: boolean;
  materialize_tags?: boolean;
  msec_per_call?: number;
  msec_per_text?: number;
  managed_by_datatrust: boolean;
  approved_for_10_dlc: boolean;
  business_street_address?: string;
  business_street_address2?: string;
  business_city?: string;
  business_state_province_region?: string;
  business_postal_code?: string;
  business_name?: string;
  business_website?: string;
  stripe_id?: string;
  stripe_subscription_id?: string;
  bandwidth_site_id?: string;
  bandwidth_peer_id?: string;
  uses_bandwidth: boolean;
  business_entity_type?: string;
  business_ein?: string;
  business_cv_token?: string;
  can_canvass: boolean;
  can_call: boolean;
  can_text: boolean;
  can_poll: boolean;
  can_custom_model: boolean;
  can_access_consumer_data: boolean;
  can_access_abev: boolean;
  can_access_campaigns: boolean;
  can_access_unreg_voters: boolean;
  can_access_canvassing_qa: boolean;
  can_access_crm: boolean;
  hubspot_id?: string;
  hubspot_deal_id?: string;
  contact_email?: string;
  contact_phone_number?: string;
  description?: string;
  is_public: boolean;
  allow_subscription_update: boolean;
  relational_survey_id: string | null;
  relational_text_id: string | null;
  relational_texting_list_id: string | null;
  relational_canvassing_list_id: string | null;
  relational_abev_election_id: number | null;
  has_basic_text_verification_info?: boolean;
  has_10dlc_text_verification_info?: boolean;
  parent_org_id?: string;
  parent_org_handles_payment?: boolean;
  is_numinar_admin_org?: boolean;
  status: OrgStatusType;
  approved_at?: Date;
  rejected_by?: string;
  rejected_at?: Date;
  state_gop?: string;
  is_state_gop?: boolean;
  has_relational_enabled: boolean;
  has_mobile_leaderboard_enabled?: boolean;
  is_disabled?: boolean;
  has_paid_relational_enabled?: boolean;
  paid_relational_payout_per_contact?: number;
  paid_relational_maximum_payout_per_user?: number;
  subsidize_canvass?: boolean;
  subsidize_relational?: boolean;
  subsidize_voter_file?: boolean;
  subsidize_call?: boolean;
  subsidize_text?: boolean;
  subsidize_poll?: boolean;
  subsidize_custom_model?: boolean;
  use_databricks?: boolean;
  timezone: string;
  canvassing_qa_distance_from_door_enabled: boolean;
  canvassing_qa_distance_from_door_percent: number;
  canvassing_qa_distance_from_door_min_doors: number;
  canvassing_qa_distance_from_door_feet: number;
  canvassing_qa_interactions_per_hour_enabled: boolean;
  canvassing_qa_interactions_per_hour_count: number;
  canvassing_qa_interactions_per_hour_min_count: number;
  canvassing_qa_doors_per_hour_enabled: boolean;
  canvassing_qa_doors_per_hour_count: number;
  canvassing_qa_doors_per_hour_min_count: number;
  canvassing_qa_survey_success_rate_enabled: boolean;
  canvassing_qa_survey_success_rate_percent: number;
  canvassing_qa_survey_success_min_doors: number;
  signup_source?: string;
  invoice_overdue?: boolean;
  billing_call_survey_price?: number;
  billing_sms_price?: number;
  billing_mms_price?: number;
  billing_call_price?: number;
  billing_text_survey_price?: number;
  billing_outreach_discount?: number;
  billing_call_per_minute_price?: number;
  user_accepted_dt_terms?: boolean;
  per_minute_billing_enabled?: boolean;
};

export type OrgTypeWithRole = OrgType & {
  user_org_role: Role;
  canvassing_qa_notification_frequency?: CanvassingQANotificationFrequency;
  invite_status: InviteStatus;
};

export type OrgTypeWithStats = OrgTypeWithRole & {
  doors: number;
  doors_canvassed: number;
  doors_flagged: number;
  doors_canvassed_flagged: number;
  doors_no_gps: number;
  doors_canvassed_no_gps: number;
  calls: number;
  calls_answered: number;
  surveys: number;
  texts: number;
  text_surveys: number;
  ivrs: number;
  tags: number;
  mail: number;
  relational: number;
  users: number;
};

export type OrgChildrenPayload = {
  start_datetime?: string;
  end_datetime?: string;
  include_archived?: boolean;
  should_group_canvasses_by_household?: boolean;
};

export type UpdateOrgType = {
  org_type?: string;
  name?: string;
  opponent?: string;
  picture_url?: string;
  email?: string;
  phone_number?: string;
  callback_phone_number?: string;
  election_type?: string;
  election_day?: Date;
  subscription?: string;
  testing_channel?: string;
  uploadcare_uuid?: string;
  candidate_name?: string;
  msec_per_call?: number;
  msec_per_text?: number;
  data_source?: string;
  business_street_address?: string;
  business_street_address2?: string;
  business_city?: string;
  business_state_province_region?: string;
  business_postal_code?: string;
  business_name?: string;
  business_website?: string;
  approved_for_10_dlc?: boolean;
  stripe_id?: string;
  stripe_subscription_id?: string;
  uses_bandwdith?: boolean;
  business_entity_type?: string;
  business_ein?: string;
  business_cv_token?: string;
  can_canvass?: boolean;
  can_call?: boolean;
  can_text?: boolean;
  can_poll?: boolean;
  can_custom_model?: boolean;
  can_access_consumer_data?: boolean;
  can_access_abev?: boolean;
  can_access_unreg_voters?: boolean;
  can_access_canvassing_qa?: boolean;
  can_access_crm?: boolean;
  invoice_overdue?: boolean;
  hubspot_id?: string;
  hubspot_deal_id?: string;
  contact_email?: string;
  contact_phone_number?: string;
  description?: string;
  is_public?: boolean;
  allow_subscription_update?: boolean;
  relational_survey_id?: string | null;
  relational_text_id?: string | null;
  relational_texting_list_id?: string | null;
  relational_canvassing_list_id?: string | null;
  relational_abev_election_id?: number | null;
  is_numinar_admin_org?: boolean;
  slug?: string;
  state_gop?: string;
  is_state_gop?: boolean;
  has_relational_enabled?: boolean;
  has_mobile_leaderboard_enabled?: boolean;
  is_disabled?: boolean;
  has_paid_relational_enabled?: boolean;
  paid_relational_payout_per_contact?: number;
  paid_relational_maximum_payout_per_user?: number;
  should_create_mv?: boolean;
  subsidize_canvass?: boolean;
  subsidize_relational?: boolean;
  subsidize_voter_file?: boolean;
  subsidize_call?: boolean;
  subsidize_text?: boolean;
  subsidize_poll?: boolean;
  subsidize_custom_model?: boolean;
  rnc_shareback?: boolean;
  race_typeRace?: string;
  selected_state?: string;
  selected_state_list?: string[];
  selected_city?: string;
  selected_county?: string;
  selected_congressional_district?: string;
  selected_senate_district?: string;
  selected_house_district?: string;
  selected_jurisdiction?: string;
  timezone?: string;
  canvassing_qa_distance_from_door_enabled?: boolean;
  canvassing_qa_distance_from_door_percent?: number;
  canvassing_qa_distance_from_door_min_doors?: number;
  canvassing_qa_distance_from_door_feet?: number;
  canvassing_qa_interactions_per_hour_enabled?: boolean;
  canvassing_qa_interactions_per_hour_count?: number;
  canvassing_qa_interactions_per_hour_min_count?: number;
  canvassing_qa_doors_per_hour_enabled?: boolean;
  canvassing_qa_doors_per_hour_count?: number;
  canvassing_qa_doors_per_hour_min_count?: number;
  canvassing_qa_survey_success_rate_enabled?: boolean;
  canvassing_qa_survey_success_rate_percent?: number;
  canvassing_qa_survey_success_min_doors?: number;
  billing_call_survey_price?: number;
  billing_sms_price?: number;
  billing_mms_price?: number;
  billing_call_price?: number;
  billing_text_survey_price?: number;
  billing_outreach_discount?: number;
  billing_call_per_minute_price?: number;
  per_minute_billing_enabled?: boolean;
};

export type CreateOrgInputType = {
  org_type: string;
  name: string;
  data_source: string;
  email: string;
  opponent?: string;
  candidate_name?: string;
  phone_number?: string;
  race_typeRace?: string;
  election_type?: string;
  selected_state: string;
  selected_state_list?: string[];
  selected_city?: string;
  selected_county?: string;
  selected_congressional_district?: string;
  selected_senate_district?: string;
  selected_house_district?: string;
  selected_jurisdiction?: string;
  election_day?: Date;
  picture_url?: string;
  uploadcare_uuid?: string;
  owner_full_name?: string;
  managed_by_datatrust?: boolean;
  stripe_id?: string;
  stripe_subscription_id?: string;
  can_canvass?: boolean;
  can_call?: boolean;
  can_text?: boolean;
  can_poll?: boolean;
  can_custom_model?: boolean;
  can_access_consumer_data?: boolean;
  can_access_abev?: boolean;
  can_access_unreg_voters?: boolean;
  can_access_canvassing_qa?: boolean;
  can_access_crm?: boolean;
  has_relational_enabled?: boolean;
  has_paid_relational_enabled?: boolean;
  allow_subscription_update?: boolean;
  parent_org_id?: string;
  state_gop?: string;
  is_state_gop?: boolean;
  copy_parent_org_stripe?: boolean;
  copy_parent_org_hubspot?: boolean;
  rnc_shareback?: boolean;
};

export type OrgSlugType = {
  id: string;
  slug: string;
  name: string;
};

export type DashboardRefreshType = {
  election_type?: string;
  issue_tag_name?: string;
};

export type OrgStatusType =
  | 'active'
  | 'pending'
  | 'pending-numinar-admin-approval'
  | 'rejected'
  | 'archived';

export enum OrgStatus {
  Active = 'active',
  Pending = 'pending',
  PendingNuminarAdminApproval = 'pending-numinar-admin-approval',
  Rejected = 'rejected',
  Archived = 'archived',
}

export type OrgSSEData = {
  order_status: string;
};
